import React from 'react';
import {
    Header,
    Grid, Segment
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';

import { FormattedMessage } from 'react-intl';
import CreateNewPollForm from './CreateNewPollFormw';
import RadioQuestionForm from '../QuestionForms/RadioQuestionForm';
import SliderQuestionForm from '../QuestionForms/SliderQuestionForm';


export default class CreateNewPoll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


        };
    }


    render() {
        return (
            <div>
                <Header as="h1" >
                    {/* <FormattedMessage id="common.notice"></FormattedMessage> */}
                    Kreiranje ankete
                </Header>
                <Grid columns={2} centered stackable>
                    <Grid.Row>
                        <Grid.Column width={16} stretched>
                            <CreateNewPollForm />
                        </Grid.Column>
                    </Grid.Row>



                </Grid>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/CreatePoll/CreateNewPoll.js